const unleashConfig = {
  url: process.env.REACT_APP_UNLEASH_PROXY_URL,
  clientKey: process.env.REACT_APP_UNLEASH_PROXY_SERVER_CLIENT,
  appName: 'r1css-frontend',
  environment: process.env.REACT_APP_UNLEASH_ENV,
  refreshInterval: 1000,
};

export default unleashConfig;
